import React, {useContext} from 'react';
import {Link, Navigate} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import AuthContext from "../../context/AuthContext";
import {Loading} from '../../custom/LoadingComponent'
import {CouponStampRenewalStep0} from './TaskCouponStampRenewalStepsComponent';
import { TaskType, TaskStatus } from '../../constants/Consts';
import * as WFSteps from '../../constants/WorkflowSteps';
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';


function TaskDeserventiCertificateNew(props) {
    console.log('___TaskDeserventiCertificateNew___');
    const authContext = useContext(AuthContext);

    const methods = useForm({
        defaultValues: {
            lTask: {
                step0: {}
            }
        } 
    });
    const handleSubmit = methods.handleSubmit;


    const handleSubmitStep0AndAdvance = (data) => {
        console.log("Submit Step 0");
        console.log(JSON.stringify(data));

        const task = data.lTask;
        task.details = {
            clientId: authContext.afUser.generalSection.clientId,
            type: TaskType.CertificateRenewal,
            activeStep: 1,
            status: TaskStatus.InProgress
        };
        props.postRsvtiTask(task);
    }
    

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.mostRecentTaskId != null) {
        console.log("Forwarding....");
        return(
            <Navigate to={`/rsvti/deserventi/tasks/certificate/${props.mostRecentTaskId}`} replace />
        );
    }    
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/rsvti/deserventi/tasks">Tasks</Link>
                            <Typography color="text.primary">Adauga Task</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <Box sx={{ width:'50%'}} display="flex" justifyContent="flex-start" alignItems="flex-start">
                                <h3>Programare reinnoire adeverinta</h3>
                            </Box>
                        </Box>                
                    </Box>
                    <hr />

                    <FormProvider {...methods} > 
                    <Box>
                        <Stepper activeStep={0} sx={{marginTop:2, marginBottom: 3}}>
                            {WFSteps.couponStampRenealSteps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>

                        <form onSubmit={handleSubmit(handleSubmitStep0AndAdvance)} id={'step0Form'}>

                            <CouponStampRenewalStep0 />

                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button
                                    color="inherit"
                                    disabled={true}
                                    sx={{ mr: 1 }}
                                >
                                    Back
                                </Button>

                                <Box sx={{ flex: '1 1 auto' }} />

                                <Button  type="submit">
                                    'Next'
                                </Button>
                            </Box>

                        </form>

                    </Box>
                    </FormProvider>

                </Stack>

            </Box>
            </Container>
        );
    }
}

export default TaskDeserventiCertificateNew;